import {Incident} from "@/lib/types/statuspages.ts";
import {IncidentsTableAffectedComponentSubRow} from "@/pages/statuspages/tabs/incidents/IncidentsTableAffectedComponentSubRow.tsx";
import {IncidentsTableUpdatesSubRow} from "@/pages/statuspages/tabs/incidents/IncidentsTableUpdatesSubRow.tsx";

export interface IncidentsTableSubRowProps {
  incident: Incident;
}

export const IncidentsTableSubRow = ({incident}: IncidentsTableSubRowProps) => {
  return (
    <>
      <td colSpan={4} className={"py-3"}>
        <div className="d-flex flex-column ps-3">
          {incident.updates.map((update) => (
            <IncidentsTableUpdatesSubRow key={update.id} update={update} />
          ))}
        </div>
      </td>
      <td colSpan={3} className={"py-3"}>
        {incident.affected_components.length > 0 && (
          <>
            <div className="mb-2">
              <span className="pulseTextBodySmallBold pulse-color-gray-900">Affected Components</span>
            </div>
            <div className="d-flex flex-column gap-2">
              {incident.affected_components.map((c, idx) => (
                <IncidentsTableAffectedComponentSubRow key={`affected-component-${c.id}-${idx}`} component={c} />
              ))}
            </div>
          </>
        )}
      </td>
    </>
  );
};
